import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { Collapse as AntCollapse } from 'antd';
import styled from 'styled-components'; // copy-pasted from antd, to solve TS4023 error

var CollapsiblePaper = styled(AntCollapse)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.ant-collapse {\n    background-color: ", ";\n    max-width: 50rem;\n    margin: 2rem auto;\n    border-radius: 4px;\n    border: none;\n\n    & > .ant-collapse-item:only-child {\n      border: none;\n    }\n\n    & > .ant-collapse-item > .ant-collapse-header {\n      font-weight: bold;\n      font-size: calc(", " + 0.25rem);\n      padding-left: 3rem;\n      padding-right: 3rem;\n    }\n\n    & > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {\n      padding-left: 3rem;\n      padding-right: 3rem;\n    }\n  }\n"])), function (props) {
  return props.theme.colors.light;
}, function (props) {
  return props.theme.fontSizes.medium;
});
export default CollapsiblePaper;